import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-614a8cf7")
const _hoisted_1 = {
  key: 0,
  class: "pool-table-mobile mb-[24px]"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-[15px]\" data-v-614a8cf7>Single Stake</div><div class=\"table-title flex justify-between\" data-v-614a8cf7><div class=\"flex items-center\" data-v-614a8cf7><div data-v-614a8cf7>Pool name</div></div><div class=\"text-right\" data-v-614a8cf7>TVL &amp; APR</div></div><div class=\"mt-[12px]\" data-v-614a8cf7></div>", 3)
const _hoisted_5 = { class: "flex-column mt-[20px]" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-column justify-end" }, [
    /*#__PURE__*/_createElementVNode("div", null, "-"),
    /*#__PURE__*/_createElementVNode("div", null, "-"),
    /*#__PURE__*/_createElementVNode("div", null, "-")
  ])
], -1)
const _hoisted_8 = {
  key: 1,
  class: "pool-table mb-[40px]"
}
const _hoisted_9 = { class: "table-title mt-[48px] flex w-full" }
const _hoisted_10 = { class: "grid-table" }
const _hoisted_11 = { class: "pool-header" }
const _hoisted_12 = { class: "heading h-4 " }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Single Stake")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-4 text-right" }, "APR", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "h-4 text-right" }, "Liquidity", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "h-4 text-right" }, "Volume (24h)", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1)
const _hoisted_19 = { class: "flex w-full items-center" }
const _hoisted_20 = { class: "ml-[24px] text-left pool-name" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-end apr" }, "-", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-end liq" }, "-", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-end vol" }, "-", -1)
_popScopeId()

import { format } from 'date-fns';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { ColumnDefinition } from '@/components/_global/BalTable/BalTable.vue';
import BalChipNew from '@/components/chips/BalChipNew.vue';
import { PRETTY_DATE_FORMAT } from '@/components/forms/lock_actions/constants';
import { POOL_MIGRATIONS_MAP } from '@/components/forms/pool_actions/MigrateForm/constants';
import { PoolMigrationType } from '@/components/forms/pool_actions/MigrateForm/types';
import APRTooltip from '@/components/tooltips/APRTooltip/APRTooltip.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import useDarkMode from '@/composables/useDarkMode';
import useFathom from '@/composables/useFathom';
import useNumbers from '@/composables/useNumbers';
import {
  absMaxApr,
  isMigratablePool,
  isStableLike,
  orderedPoolTokens,
  orderedTokenAddresses,
  totalAprLabel,
} from '@/composables/usePool';
import { bnum } from '@/lib/utils';
import { PoolWithShares } from '@/services/pool/types';
import { POOLS } from '@/constants/pools';
import singleStakeImg from './pool-icon-single-stake.svg';
import PoolsTableActionsCell from './PoolsTableActionsCell.vue';


export default _defineComponent({
  emits: ['loadMore', 'triggerStake'],
  setup(__props, { emit }) {

const { isMobile, isDesktop } = useBreakpoints();


/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const router = useRouter();
const { t } = useI18n();
const { trackGoal, Goals } = useFathom();
const { darkMode } = useDarkMode();
const { upToLargeBreakpoint, upToMediumBreakpoint } = useBreakpoints();

const wideCompositionWidth = computed(() =>
  upToMediumBreakpoint.value ? 450 : undefined
);

/**
 * DATA
 */
const columns = computed<ColumnDefinition<PoolWithShares>[]>(() => [
  {
    name: 'Icons',
    id: 'icons',
    accessor: 'uri',
    Header: 'iconColumnHeader',
    Cell: 'iconColumnCell',
    width: 125,
    noGrow: true,
  },
  {
    name: t('composition'),
    id: 'poolName',
    accessor: 'id',
    Cell: 'poolNameCell',
    width: props.hiddenColumns.length >= 2 ? wideCompositionWidth.value : 350,
  },
  {
    name: t('myBalance'),
    accessor: pool =>
      fNum2(pool.shares, {
        style: 'currency',
        maximumFractionDigits: 0,
        fixedFormat: true,
      }),
    align: 'right',
    id: 'myBalance',
    hidden: !props.showPoolShares,
    sortKey: pool => Number(pool.shares),
    width: 160,
    cellClassName: 'font-numeric',
  },
  {
    name: t('poolValue'),
    accessor: pool =>
      fNum2(pool.totalLiquidity, {
        style: 'currency',
        maximumFractionDigits: 0,
      }),
    align: 'right',
    id: 'poolValue',
    sortKey: pool => {
      const apr = Number(pool.totalLiquidity);
      if (apr === Infinity || isNaN(apr)) return 0;
      return apr;
    },
    width: 150,
    cellClassName: 'font-numeric',
  },
  {
    name: t('volume24h', [t('hourAbbrev')]),
    accessor: pool => pool?.volumeSnapshot || '0',
    align: 'right',
    id: 'poolVolume',
    Cell: 'volumeCell',
    sortKey: pool => {
      const volume = Number(pool?.volumeSnapshot);
      if (volume === Infinity || isNaN(volume)) return 0;
      return volume;
    },
    width: 175,
    cellClassName: 'font-numeric',
  },
  {
    name: t('myBoost'),
    accessor: pool =>
      pool?.boost ? `${bnum(pool?.boost).toFixed(3)}x` : 'N/A',
    align: 'right',
    id: 'myBoost',
    hidden: !props.showBoost,
    sortKey: pool => Number(pool?.boost || '0'),
    width: 150,
    cellClassName: 'font-numeric',
  },
  {
    name: props.showPoolShares ? t('myApr') : t('apr'),
    Cell: 'aprCell',
    accessor: pool => pool?.apr?.total.unstaked || '0',
    align: 'right',
    id: 'poolApr',
    sortKey: pool => {
      let apr = 0;

      if (pool?.apr) {
        apr = Number(absMaxApr(pool.apr, pool.boost));
      }

      return isFinite(apr) ? apr : 0;
    },
    width: 250,
  },
  {
    name: t('expiryDate'),
    Cell: 'lockEndDateCell',
    accessor: 'lockedEndDate',
    align: 'right',
    id: 'lockEndDate',
    width: 150,
  },
  {
    name: t('migrate'),
    Cell: 'migrateCell',
    accessor: 'migrate',
    align: 'center',
    id: 'migrate',
    width: 150,
  },
  {
    name: t('actions'),
    Cell: 'actionsCell',
    accessor: 'actions',
    align: 'center',
    id: 'actions',
    width: 150,
  },
]);

function findCommonElements3(arr1, arr2) {
  for (let el1 of arr1) {
    for (let el2 of arr2) {
      if (el1.toLowerCase() === el2.toLowerCase()) {
        return false;
      }
    }
  }
  return true;
}

// const data = computed(() => (upToMediumBreakpoint.value ? 450 : undefined));
const pools = computed(() => [
  { name: 'POLAR', id: '0xf0f3b9Eee32b1F490A4b8720cf6F005d4aE9eA86' },
  { name: 'ORBITAL', id: '0x3AC55eA8D2082fAbda674270cD2367dA96092889' },
  { name: 'BINARIS', id: '0xafE0d6ca6AAbB43CDA024895D203120831Ba0370' },
  { name: 'USP', id: '0xa69d9Ba086D41425f35988613c156Db9a88a1A96' },
  { name: 'ETHERNAL', id: '0x17cbd9C274e90C537790C51b4015a65cD015497e' },
  { name: 'PBOND', id: '0x3a4773e600086A753862621A26a2E3274610da43' },
  { name: 'OBOND', id: '0x192bdcdd7b95A97eC66dE5630a85967F6B79e695' },
  { name: 'BBOND', id: '0xfa32616447C51F056Db97BC1d0E2D4C0c4D059C9' },
  { name: 'USPBOND', id: '0xcE32b28c19C61B19823395730A0c7d91C671E54b' },
  { name: 'EBOND', id: '0x266437E6c7500A947012F19A3dE96a3881a0449E' },
]);

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pools), (pool, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex w-full items-center",
              key: idx
            }, [
              _createVNode(_component_router_link, {
                class: "flex w-full items-center justify-between",
                to: '/singlestake/' + pool.name.toLowerCase()
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_BalAsset, {
                      address: pool.id,
                      size: 36,
                      width: "100"
                    }, null, 8, ["address"]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(pool.name), 1)
                  ]),
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      width: "24",
                      height: "14",
                      class: "pool-icon inline-block mr-2",
                      src: _unref(singleStakeImg)
                    }, null, 8, _hoisted_13),
                    _hoisted_14
                  ])
                ]),
                _hoisted_15,
                _hoisted_16,
                _hoisted_17
              ]),
              _hoisted_18,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pools), (pool, idx) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: idx,
                  to: '/singlestake/' + pool.name.toLowerCase(),
                  class: "my-[18px] flex w-full items-center pool-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_BalAsset, {
                        address: pool.id,
                        size: 36,
                        width: "100"
                      }, null, 8, ["address"]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(pool.name), 1)
                    ]),
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})